// src/context/FeatureFlagContext.js
import React, { createContext } from "react";
import { envVariables } from "../config/appConfig";

export const FeatureFlagContext = createContext({});

export const FeatureFlagProvider = ({ children }) => {
  const featureFlags = {
    flags: {
      featureLanguageOptions: envVariables.LANGUAGE_OPTIONS,
      featureShowLoginUrl: envVariables.SHOW_LOGIN_URL,
      featureEnableMobileAppDownloads: envVariables.ENABLE_MOBILE_APP_DOWNLOADS,
      featureEnableSocialLinks: envVariables.FEATURE_ENABLE_SOCIAL_LINKS,
      iosAppDownloadUrl: envVariables.RELIANCE_IOS_APP_DOWNLOAD_URL,
      androidAppDownloadUrl: envVariables.RELIANCE_ANDROID_APP_DOWNLOAD_URL,
      supportFacebookUrl: envVariables.SUPPORT_FACEBOOK_URL,
      supportWhatsAppNumber: envVariables.SUPPORT_WHATSAPP_NUMBER,
      supportPhoneNumber: envVariables.SUPPORT_PHONE_NUMBER,
      supportEmail: envVariables.SUPPORT_EMAIL,
      countryLocale: envVariables.COUNTRY_LOCALE,
      accountDashboardUrl: envVariables.ACCOUNTS_DASHBOARD_URL,
    },
  };

  return (
    <FeatureFlagContext.Provider value={featureFlags}>
      {children}
    </FeatureFlagContext.Provider>
  );
};
